module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "audition-item"
  }, [_c('div', {
    staticClass: "head-img-wrapper"
  }, [_c('img', {
    attrs: {
      "src": _vm.imgUrl
    }
  }), _vm._v(" "), (_vm.recruitmentType === 2) ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(!_vm.playFlag) ? _c('div', {
    staticClass: "unplayed"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('word.unlisten')))])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "custom-class": "dialog",
      "title": _vm.muiltChooseAnchor,
      "size": "small"
    },
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('el-form', [_c('el-form-item', [_c('div', {
    staticStyle: {
      "display": "block",
      "width": "900px",
      "height": "50px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    },
    on: {
      "click": _vm.getNewAnchors
    }
  }, [_c('i', {
    staticClass: "icon-refresh"
  }), _vm._v(" "), _c('span', {
    staticClass: "refresh"
  }, [_vm._v(_vm._s(_vm.$t('word.switch')))])])]), _vm._v(" "), _c('div', {
    staticClass: "content-cards"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.curIndex),
      expression: "curIndex"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.curIndex)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.curIndex = $event.target.value
      }
    }
  }), _vm._v(" "), _vm._l((_vm.anchors), function(anchor, index) {
    return _c('anchor-card', {
      attrs: {
        "selected": _vm.curIndex === index,
        "anchor": anchor
      },
      nativeOn: {
        "click": function($event) {
          _vm.setAnchor(index)
        }
      }
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('word.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.sendInvitation
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.inviteAnchor')))])], 1)], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "audition-item-right"
  }, [_c('div', {
    staticClass: "audition-content-top"
  }, [_c('a', {
    staticClass: "anchor-name",
    attrs: {
      "href": _vm.getUserInfoUrl()
    }
  }, [_vm._v(_vm._s(_vm.anchorName))]), _c('i', {
    staticClass: "icon icon-vip",
    class: _vm.vipIconClass,
    staticStyle: {
      "margin-right": "15px"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fans-count"
  }, [_vm._v(_vm._s(_vm.$t('word.fans')) + ": " + _vm._s(_vm.fansCount))]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.formatDate))]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.description,
      "placement": "top",
      "effect": "dark",
      "popper-class": "popper"
    }
  }, [_c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [(_vm.allowOperate && _vm.inviteStatus === 4) ? _c('div', {
    staticClass: "refuse-wrapper"
  }, [_c('span', {
    staticClass: "refuse"
  }, [_vm._v(_vm._s(_vm.$t('comb.invitationRefuse')))]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.offerRejectedReason,
      "placement": "top",
      "effect": "dark",
      "popper-class": "popper"
    }
  }, [_c('i', {
    staticClass: "question-mark"
  })])], 1) : _vm._e(), _vm._v(" "), (_vm.allowOperate && _vm.recruitmentType === 2 && _vm.inviteStatus === 4) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canInvite
    },
    on: {
      "click": _vm.sendAudition
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.sendAgain')))]) : _vm._e(), _vm._v(" "), (_vm.allowOperate && _vm.recruitmentType === 1 && _vm.inviteStatus === 4) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canInvite
    },
    on: {
      "click": function($event) {
        _vm.getNewAnchors();
        _vm.dialogVisible = !_vm.dialogVisible
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('sen.chooseAnotherAnchor')))]) : _vm._e(), _vm._v(" "), (_vm.allowOperate && _vm.inviteStatus === 2 || _vm.inviteStatus === 3) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": true
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.invitationSent')))]) : _vm._e(), _vm._v(" "), (_vm.allowOperate && _vm.inviteStatus === 1) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.canInvite
    },
    on: {
      "click": _vm.sendAudition
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.sendInvitation')))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "audition-content-bottom",
    class: {
      'flex-end': _vm.recruitmentType === 1
    }
  }, [(_vm.recruitmentType === 2) ? _c('div', {
    staticClass: "player",
    attrs: {
      "sound_id": _vm.fileId,
      "sound_src": ("" + _vm.UPLOAD_IMG_HOST + _vm.audioUrl),
      "sound_duration": _vm.duration,
      "sound_playusage": "2"
    }
  }, [_c('div', {
    staticClass: "works-item-content"
  }, [_c('div', [_c('div', {
    staticClass: "xm-player"
  }, [_c('i', {
    staticClass: "player_btn",
    on: {
      "click": _vm.changeStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "player_progressbar"
  }, [_c('div', {
    staticClass: "player_seekbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "player_playbar"
  }), _vm._v(" "), _c('div', {
    staticClass: "player_wavebox",
    attrs: {
      "sound_wave": ("" + _vm.UPLOAD_IMG_HOST + _vm.waveUrl),
      "sound_uploadid": ("u_" + _vm.fileId)
    }
  })]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "player_position"
  }, [_vm._v("00:00")]), _vm._v("\n                                    /\n                                    "), _c('span', {
    staticClass: "player_duration"
  }, [_vm._v(_vm._s(_vm.formatDuration))])])])])])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-83259132!./~/vue-loader/lib/selector.js?type=template&index=0!./views/components/AuditionItem.vue
// module id = 1082
// module chunks = 0